__turbopack_context__.v({
  "action": "RelayNumberPicker-module-scss-module__G7tdgq__action",
  "button": "RelayNumberPicker-module-scss-module__G7tdgq__button",
  "controls": "RelayNumberPicker-module-scss-module__G7tdgq__controls",
  "description": "RelayNumberPicker-module-scss-module__G7tdgq__description",
  "form": "RelayNumberPicker-module-scss-module__G7tdgq__form",
  "is-error": "RelayNumberPicker-module-scss-module__G7tdgq__is-error",
  "is-hidden": "RelayNumberPicker-module-scss-module__G7tdgq__is-hidden",
  "is-secondary": "RelayNumberPicker-module-scss-module__G7tdgq__is-secondary",
  "is-success": "RelayNumberPicker-module-scss-module__G7tdgq__is-success",
  "lead": "RelayNumberPicker-module-scss-module__G7tdgq__lead",
  "loading": "RelayNumberPicker-module-scss-module__G7tdgq__loading",
  "paragraph": "RelayNumberPicker-module-scss-module__G7tdgq__paragraph",
  "phone-number": "RelayNumberPicker-module-scss-module__G7tdgq__phone-number",
  "search": "RelayNumberPicker-module-scss-module__G7tdgq__search",
  "show-more-options": "RelayNumberPicker-module-scss-module__G7tdgq__show-more-options",
  "spin": "RelayNumberPicker-module-scss-module__G7tdgq__spin",
  "step": "RelayNumberPicker-module-scss-module__G7tdgq__step",
  "step-input-verificiation-code": "RelayNumberPicker-module-scss-module__G7tdgq__step-input-verificiation-code",
  "step-input-verificiation-code-lead-default": "RelayNumberPicker-module-scss-module__G7tdgq__step-input-verificiation-code-lead-default",
  "step-input-verificiation-code-lead-error": "RelayNumberPicker-module-scss-module__G7tdgq__step-input-verificiation-code-lead-error",
  "step-input-verificiation-code-lead-success": "RelayNumberPicker-module-scss-module__G7tdgq__step-input-verificiation-code-lead-success",
  "step-input-verificiation-code-success": "RelayNumberPicker-module-scss-module__G7tdgq__step-input-verificiation-code-success",
  "step-select-phone-number-mask": "RelayNumberPicker-module-scss-module__G7tdgq__step-select-phone-number-mask",
  "step-select-phone-number-mask-loading": "RelayNumberPicker-module-scss-module__G7tdgq__step-select-phone-number-mask-loading",
  "step-select-relay-numbers-radio-group": "RelayNumberPicker-module-scss-module__G7tdgq__step-select-relay-numbers-radio-group",
  "step-welcome": "RelayNumberPicker-module-scss-module__G7tdgq__step-welcome",
});
